module.exports = __webpack_public_path__ + "img/oillink.daf7522e.png";